import React, { useEffect } from 'react';
import { useAnalytics } from 'reaxl-analytics';

import {
    PageSection,
    Button,
    Glyphicon,
} from 'reaxl';

function TariffAdBarContainer() {
    const { sendClick, sendImpressions } = useAnalytics();

    useEffect(() => {
        sendImpressions({
            name: 'tariffImpression',
            data: {
                label: 'cta::tariff-ad::articles_car-shopping::need-to-know',
            },
        });
        sendImpressions({
            name: 'tariffImpression',
            data: {
                label: 'cta::tariff-ad::srp::shop-your-new-car',
            },
        });
    }, []);

    return (
        <div className="tariff-ad-bar-section-container">
            <PageSection
                containerClassname="padding-horizontal-0"
                sectionContainerClassNames="row padding-vertical-2 padding-vertical-md-3"
                coloredBackgroundContext="default"
                offset={2}
            >
                <div className="tariff-ad-bar-container">
                    <Button
                        className="tariff-cta padding-horizontal-0 margin-right-3"
                        bsSize="small"
                        bsStyle="link"
                        href="/tariffs"
                        onClick={(e) => {
                            sendClick('tariffClick', e, { label: 'cta::tariff-ad::articles_car-shopping::need-to-know' });
                        }}
                    >
                        <div className="display-flex justify-content-center align-items-center">
                            <span className="cursor-pointer text-right">
                                New Tariffs: What You Need to Know
                            </span>
                            <Glyphicon
                                glyph="chevron-right"
                                className="text-bold margin-left-4"
                            />
                        </div>
                    </Button>
                    <Button
                        className="tariff-cta padding-horizontal-0 margin-0"
                        bsSize="small"
                        bsStyle="link"
                        href="/cars-for-sale/new-cars"
                        onClick={(e) => {
                            sendClick('tariffClick', e, { label: 'cta::tariff-ad::srp::shop-your-new-car' });
                        }}
                    >
                        <div className="display-flex justify-content-center align-items-center">
                            <span className="cursor-pointer text-right">
                                Shop Your New Car Before Costs Go Up
                            </span>
                            <Glyphicon
                                glyph="chevron-right"
                                className="text-bold margin-left-4"
                            />
                        </div>
                    </Button>
                </div>
            </PageSection>
        </div>
    );
}

export default TariffAdBarContainer;
